import * as React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Unstable_Grid2';
import Tooltip from '@mui/material/Tooltip';
import { DEFAULT_SHADOW } from 'styles/theme';

const minTooltipLength = 20;

const StyFolderCard = styled(Paper, {
    name: 'StyFolderCard',
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ isSelected, theme }) => ({
    ...DEFAULT_SHADOW,
    height: '4rem',
    padding: '0 1.5rem',
    display: 'flex',
    alignItems: 'center',
    borderColor: theme.palette.primary.main,
    ...(isSelected
        ? {
              borderStyle: 'solid',
              borderWidth: '2px',
              color: theme.palette.primary.main,
          }
        : {
              '&:hover': {
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  color: theme.palette.primary.main,
              },
          }),
}));

const StyTooltipTitle = styled(Typography, {
    name: 'StyTooltipTitle',
})({
    // creates ellipsis but on 3 lines
    // see https://css-tricks.com/almanac/properties/l/line-clamp/
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    // we use max height for old Firefox version that do not support line clamp
    maxHeight: '57px',
    color: 'inherit',
});

type Props = {
    title: string;
    isSelected: boolean;
    onClick(): void;
    icon?: React.ReactNode;
};

const FolderCard = ({
    icon,
    title,
    isSelected,
    onClick,
}: Props): React.ReactElement => {
    const titleComponent = (
        <Tooltip
            title={title && title.length >= minTooltipLength ? title : ''}
            enterDelay={500}
        >
            <StyTooltipTitle variant="body1SemiBold">{title}</StyTooltipTitle>
        </Tooltip>
    );

    return (
        <Grid xs={6} data-e2e={title}>
            <StyFolderCard isSelected={isSelected} onClick={onClick}>
                {icon && <Box sx={{ mr: '0.8rem' }}>{icon}</Box>}
                {titleComponent}
            </StyFolderCard>
        </Grid>
    );
};

export default FolderCard;
